export const getAllAISessionsGQL = /* GraphQL */ `
  query GetAllAISessions($organizationID: String!) {
    getAllAISessions(organizationID: $organizationID) {
      statusCode
      message
      sessions
    }
  }
`;
export const getAISessionGQL = /* GraphQL */ `
  query GetAISession($organizationID: String!, $sessionId: String!) {
    getAISession(organizationID: $organizationID, sessionId: $sessionId) {
      statusCode
      message
      session
    }
  }
`;
export const runQueryGQL = /* GraphQL */ `
  query RunQuery($organizationID: String!, $queryName: String!, $args: AWSJSON) {
    runQuery(organizationID: $organizationID, queryName: $queryName, args: $args) {
      statusCode
      message
      results
    }
  }
`;
//# sourceMappingURL=ConversationModel.js.map